export default __webpack_public_path__ + "static/05-qs-chile-large-03d94cfb2047c8ae5d5e20f127d3baa2.svg";